import { render, staticRenderFns } from "./management-transfer-library-view.vue?vue&type=template&id=2018785e"
import script from "./management-transfer-library-view.vue?vue&type=script&lang=js"
export * from "./management-transfer-library-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports